import React from 'react';

const IrisLogo = ({ className = "", width = "40", height = "40" }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Shield Background */}
      <path
        d="M12 2L3 7V12C3 16.97 7.02 21.5 12 22.5C16.98 21.5 21 16.97 21 12V7L12 2Z"
        fill="url(#shieldGradient)"
        stroke="url(#strokeGradient)"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      
      {/* Inner Shield Layer */}
      <path
        d="M12 4.5L5.5 8V12C5.5 15.5 8.5 18.8 12 19.8C15.5 18.8 18.5 15.5 18.5 12V8L12 4.5Z"
        fill="none"
        stroke="rgba(255, 255, 255, 0.3)"
        strokeWidth="0.75"
      />
      
      {/* Checkmark / Lock Symbol */}
      <path
        d="M9 12L11 14L15 10"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Corner Indicators */}
      <circle cx="6" cy="8" r="1" fill="#06B6D4" opacity="0.9">
        <animate attributeName="opacity" values="0.9;1;0.9" dur="2s" repeatCount="indefinite"/>
      </circle>
      <circle cx="18" cy="8" r="1" fill="#06B6D4" opacity="0.9">
        <animate attributeName="opacity" values="0.9;1;0.9" dur="2s" repeatCount="indefinite" begin="0.5s"/>
      </circle>
      
      {/* Gradients */}
      <defs>
        <linearGradient id="shieldGradient" x1="12" y1="2" x2="12" y2="22.5" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#0066CC"/>
          <stop offset="100%" stopColor="#1E3A8A"/>
        </linearGradient>
        
        <linearGradient id="strokeGradient" x1="3" y1="2" x2="21" y2="22.5" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#06B6D4"/>
          <stop offset="100%" stopColor="#0EA5E9"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IrisLogo;
